import type { TourDefinition } from '../../types/tour';

export const realtimeFirstVisitTour: TourDefinition = {
  key: 'realtime_first_visit',
  title: 'リアルタイム会議ツアー',
  steps: [
    {
      target: '#meeting-start-button',
      title: '会議の始め方',
      content:
        'このカードから会議を開始できます。相手を選んでおくと、過去のやり取りを思い出しながらより寄り添ったサポートができます。',
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '#tour-anchor-participants',
      title: '相手を選ぶ',
      content:
        '相手を設定すると、記憶ベースの提案が有効になります。過去の会話・関心事・未解決事項を AI が思い出してサポートします。',
      placement: 'bottom',
    },
    {
      target: '#tour-anchor-start',
      title: '会議を始める',
      content:
        '準備ができたら、このボタンから会議を始めます。会議中でも参加者を追加・変更できます。',
      placement: 'top',
    },
  ],
};
